import React from 'react';
import { motion } from 'framer-motion';
export function TransformationSection() {
  return <section className="py-12 bg-aged-cream text-slate-900 relative overflow-hidden" data-id="element-327">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: 'radial-gradient(#1a3d3d 1px, transparent 1px)',
      backgroundSize: '30px 30px'
    }} data-id="element-328"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-329">
        <div className="bg-white p-8 md:p-12 rounded-2xl border-2 border-[#1a3d3d] shadow-xl max-w-4xl mx-auto" data-id="element-330">
          <div className="text-center mb-16" data-id="element-331">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="text-4xl md:text-5xl font-bold mb-6" data-id="element-332">
              Lo que puedes esperar en{' '}
              <span className="text-[#f4c430]" data-id="element-333">menos de 30 días</span>
            </motion.h2>
            <p className="text-xl text-slate-700 max-w-2xl mx-auto mb-4" data-id="element-334">
              Más claridad. Menos ansiedad. Decisiones sin culpa. Control real.
            </p>
            <p className="text-lg text-slate-600" data-id="element-335">
              Sin ganar más dinero. Sin dejar de vivir.
            </p>
            <div className="bg-aged-green p-6 rounded-xl border-l-4 border-[#f4c430] mt-6 max-w-md mx-auto overflow-hidden" data-id="element-336">
              <p className="text-xl font-bold text-[#f4c430] relative z-10" data-id="element-337">
                Esa es la promesa.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}